import * as React from "react"
import type { SVGProps } from "react"
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.71q-.82 0-1.41-.58A2 2 0 0 1 3 19.7v-14q0-.83.59-1.4A2 2 0 0 1 5 3.7h6q.42 0 .71.3.3.27.29.7 0 .43-.29.72a1 1 0 0 1-.71.28H5v14h6q.42 0 .71.3.3.28.29.7 0 .43-.29.72a1 1 0 0 1-.71.28zm12.18-8H10a1 1 0 0 1-.71-.28A1 1 0 0 1 9 12.7q0-.43.29-.7a1 1 0 0 1 .71-.3h7.18L15.3 9.84a1 1 0 0 1-.28-.67q0-.4.28-.7a1 1 0 0 1 .7-.32 1 1 0 0 1 .73.29l3.57 3.58a.96.96 0 0 1 0 1.4l-3.57 3.57a1 1 0 0 1-.72.29 1 1 0 0 1-.71-.32 1 1 0 0 1-.26-.7 1 1 0 0 1 .29-.7z" />
  </svg>
)
export default SvgLogout
